module.exports = __webpack_public_path__ + "assets/images/calendar-month-purple.08055262a8a762046af248bde3507e82.svg";